import { render } from "./Edit.vue?vue&type=template&id=6e92a32b"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/bylex_platform/cwt2/alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Projects/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6e92a32b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6e92a32b', __exports__)) {
    api.reload('6e92a32b', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=6e92a32b", () => {
    api.rerender('6e92a32b', render)
  })

}


export default __exports__